import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Container, Row, Col, Button } from "reactstrap";

const rowClass = {
  marginTop: '60px',
};
const notFoundText = {
  fontWeight: 200,
  color: 'darkgray'
};
const notFoundImage = {
  maxWidth: '50%',
  height:'auto'
};
const notFoundButton = {
  backgroundColor: 'white',
  borderColor: '#3f51b5',
  color:'#3f51b5',
  marginTop: '15px'
};

const Error404 = props => {
  return (
    <>
      <div className="main-content">
        <div className="header py-7 py-lg-8 ">
          <Container>
            <div className="header-body text-center mb-7">
              <Row className="justify-content-center" style={rowClass}>
                <Col>
                  <h1>Page Not Found</h1>
                  <p className="text-lead" style={notFoundText}>
                    We're sorry, the page your requested could not be found. Please go back to the home page or contact us at support-merchant-portal@ghl.com.ph
                  </p>
                  <img
                    alt="Under development"
                    src={require("assets/img/brand/undraw_page_not_found_su7k.svg")}
                    style={notFoundImage}
                  />
                  <div>
                    <Button
                      color="primary"
                      tag={RouterLink}
                      exact
                      to="/auth/login"
                      variant="outlined"
                      style={notFoundButton}
                    >
                      BACK TO HOME
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
}

export default Error404;
